import { render, staticRenderFns } from "./Resizable.vue?vue&type=template&id=5ee6b776&scoped=true&"
import script from "./Resizable.vue?vue&type=script&lang=js&"
export * from "./Resizable.vue?vue&type=script&lang=js&"
import style0 from "./Resizable.vue?vue&type=style&index=0&id=5ee6b776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee6b776",
  null
  
)

export default component.exports